import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { MAIN_REJESTR_API_SHORT } from '../../../../components/utils/consts.js'
import { deleteItem } from '../../../app/setters/deleteItem.js'

export const useOdwiazOsobeOdProjektu = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (data) =>
            deleteItem(
                `/${MAIN_REJESTR_API_SHORT}/odlacz/${data.rejestr_id}/${data.user_id}`
            ),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: (query) =>
                    query.queryKey[0].startsWith(`lista_profili_projektu`),
            })
        },
        onSuccess: ({ message }) => {
            toast.success(message)
        },
    })
}
